<script lang="ts" setup>
const { $t } = useLocalization();

interface Props
{
    form: any;
    modelOptions: Option[];
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false
});

const emit = defineEmits<{
    (e: 'update:form', value: any): void;
    (e: 'model-changed', value: string): void;
}>();

// Reaktywny dostęp do form
const form = computed({
    get: () => props.form,
    set: value => emit('update:form', value)
});

// Watch dla zmian modelu
watch(() => form.value.model, (newModel) =>
{
    emit('model-changed', newModel);
});
</script>

<template>
    <IdeoFormGroup>
        <div class="h5 mb-3">
            {{ $t('[[[Co chcesz wygenerować?]]]') }}
        </div>
        <IdeoFormGroup
            :invalid-feedback="form.$errors.first('prompt')"
            :state="form.$errors.state('prompt')"
        >
            <IdeoFormTextarea
                v-model="form.prompt"
                name="prompt"
                rows="3"
                :placeholder="$t('[[[office worker working at a computer]]]')"
                :disabled="form.$loading || disabled"
            />
            <template #description>
                {{ $t('[[[Dla najlepszych wyników opisz obraz w języku angielskim]]]') }}
            </template>
        </IdeoFormGroup>
        <IdeoFormGroup
            :label="$t('[[[Silnik]]]')"
            class="w-30"
            :invalid-feedback="form.$errors.first('model')"
            :state="form.$errors.state('model')"
        >
            <IdeoFormSelect
                v-model="form.model"
                :options="modelOptions"
                :disabled="form.$loading || disabled"
            />
        </IdeoFormGroup>
    </IdeoFormGroup>
</template>
